/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    ContactPerson,
    ContactPersonFromJSON,
    ContactPersonFromJSONTyped,
    ContactPersonToJSON,
    Country,
    CountryFromJSON,
    CountryFromJSONTyped,
    CountryToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyClient
 */
export interface ReadOnlyClient {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyClient
     */
    readonly id?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReadOnlyClient
     */
    readonly children?: Array<number>;
    /**
     * 
     * @type {Array<ContactPerson>}
     * @memberof ReadOnlyClient
     */
    readonly contactpersonSet?: Array<ContactPerson>;
    /**
     * 
     * @type {Array<Address>}
     * @memberof ReadOnlyClient
     */
    readonly addressNew?: Array<Address>;
    /**
     * 
     * @type {Country}
     * @memberof ReadOnlyClient
     */
    country?: Country;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyClient
     */
    countryId?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    identificationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    deleted?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClient
     */
    address?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    fieldOfActivity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    billingCode?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClient
     */
    correspondenceAddress?: object | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClient
     */
    contact?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    emailForInvocing?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    vatNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    taxNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    bankingConnection?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    timeZone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    languageIso6391?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyClient
     */
    isPartner?: boolean;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClient
     */
    styles?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    logo?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClient
     */
    metadata?: object;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyClient
     */
    costPerKm?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    fleetType?: ReadOnlyClientFleetTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyClient
     */
    forwardedToDff?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyClient
     */
    lastSyncWithDff?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    dffSyncTraceback?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyClient
     */
    mamId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyClient
     */
    ewOffice?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyClient
     */
    externalSystem?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyClient
     */
    referrer?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReadOnlyClient
     */
    readonly modules?: Array<number>;
}

export function ReadOnlyClientFromJSON(json: any): ReadOnlyClient {
    return ReadOnlyClientFromJSONTyped(json, false);
}

export function ReadOnlyClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyClient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'children': !exists(json, 'children') ? undefined : json['children'],
        'contactpersonSet': !exists(json, 'contactperson_set') ? undefined : ((json['contactperson_set'] as Array<any>).map(ContactPersonFromJSON)),
        'addressNew': !exists(json, 'address_new') ? undefined : ((json['address_new'] as Array<any>).map(AddressFromJSON)),
        'country': !exists(json, 'country') ? undefined : CountryFromJSON(json['country']),
        'countryId': !exists(json, 'country_id') ? undefined : json['country_id'],
        'externalId': !exists(json, 'external_id') ? undefined : json['external_id'],
        'identificationNumber': !exists(json, 'identification_number') ? undefined : json['identification_number'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'name': json['name'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'fieldOfActivity': !exists(json, 'field_of_activity') ? undefined : json['field_of_activity'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'billingCode': !exists(json, 'billing_code') ? undefined : json['billing_code'],
        'correspondenceAddress': !exists(json, 'correspondence_address') ? undefined : json['correspondence_address'],
        'contact': !exists(json, 'contact') ? undefined : json['contact'],
        'emailForInvocing': !exists(json, 'email_for_invocing') ? undefined : json['email_for_invocing'],
        'vatNumber': !exists(json, 'vat_number') ? undefined : json['vat_number'],
        'taxNumber': !exists(json, 'tax_number') ? undefined : json['tax_number'],
        'bankingConnection': !exists(json, 'banking_connection') ? undefined : json['banking_connection'],
        'timeZone': !exists(json, 'time_zone') ? undefined : json['time_zone'],
        'languageIso6391': !exists(json, 'language_iso_639_1') ? undefined : json['language_iso_639_1'],
        'isPartner': !exists(json, 'is_partner') ? undefined : json['is_partner'],
        'styles': !exists(json, 'styles') ? undefined : json['styles'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'costPerKm': !exists(json, 'cost_per_km') ? undefined : json['cost_per_km'],
        'fleetType': !exists(json, 'fleet_type') ? undefined : json['fleet_type'],
        'forwardedToDff': !exists(json, 'forwarded_to_dff') ? undefined : json['forwarded_to_dff'],
        'lastSyncWithDff': !exists(json, 'last_sync_with_dff') ? undefined : (json['last_sync_with_dff'] === null ? null : new Date(json['last_sync_with_dff'])),
        'dffSyncTraceback': !exists(json, 'dff_sync_traceback') ? undefined : json['dff_sync_traceback'],
        'mamId': !exists(json, 'mam_id') ? undefined : json['mam_id'],
        'ewOffice': !exists(json, 'ew_office') ? undefined : json['ew_office'],
        'externalSystem': !exists(json, 'external_system') ? undefined : json['external_system'],
        'referrer': !exists(json, 'referrer') ? undefined : json['referrer'],
        'modules': !exists(json, 'modules') ? undefined : json['modules'],
    };
}

export function ReadOnlyClientToJSON(value?: ReadOnlyClient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'country': CountryToJSON(value.country),
        'country_id': value.countryId,
        'external_id': value.externalId,
        'identification_number': value.identificationNumber,
        'deleted': value.deleted,
        'name': value.name,
        'address': value.address,
        'field_of_activity': value.fieldOfActivity,
        'language': value.language,
        'currency': value.currency,
        'billing_code': value.billingCode,
        'correspondence_address': value.correspondenceAddress,
        'contact': value.contact,
        'email_for_invocing': value.emailForInvocing,
        'vat_number': value.vatNumber,
        'tax_number': value.taxNumber,
        'banking_connection': value.bankingConnection,
        'time_zone': value.timeZone,
        'language_iso_639_1': value.languageIso6391,
        'is_partner': value.isPartner,
        'styles': value.styles,
        'logo': value.logo,
        'metadata': value.metadata,
        'cost_per_km': value.costPerKm,
        'fleet_type': value.fleetType,
        'forwarded_to_dff': value.forwardedToDff,
        'last_sync_with_dff': value.lastSyncWithDff === undefined ? undefined : (value.lastSyncWithDff === null ? null : value.lastSyncWithDff.toISOString()),
        'dff_sync_traceback': value.dffSyncTraceback,
        'mam_id': value.mamId,
        'ew_office': value.ewOffice,
        'external_system': value.externalSystem,
        'referrer': value.referrer,
    };
}

/**
* @export
* @enum {string}
*/
export enum ReadOnlyClientFleetTypeEnum {
    Trucks = 'trucks',
    LightVehicles = 'light_vehicles',
    Mixed = 'mixed'
}


